import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'

Vue.config.productionTip = false

Vue.use(Vant);

import axios from 'axios'
Vue.prototype.$axios = axios //全局注册，使用方法为:this.$axios

//禁止浏览器前进后退，另一部分在路由js中
window.addEventListener('popstate',function(){
	history.pushState(null,null,document.URL);
})

document.title = '沈阳英瑞科技股份有限公司'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
